import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';
import React from 'react';
import '../styles/App.css';
import Header from './Header.js';
import Home from './Home.js';
import ModeItem from './ModeItem.js';
import ModeGame from './ModeGame.js';
import ModeCharacter from './ModeCharacter.js';
import ModeSword from './ModeSword.js';
import Share from './Share.js';
import Socials from './Socials.js';
import Footer from './Footer.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import About from './About.js';
import Contact from './Contact.js';
import Terms from './Terms.js';
import History from './History.js';
import NotFound from './NotFound.js';
import Library from './Library.js';
import { AdRailLeft, AdRailRight } from './AdsRail.js';
import CookieConsent from './CookieConsent.js';

// Wrappers avec key basée sur l'id pour forcer un remount
// (et donc une réinitialisation complète de la partie) quand on
// change d'archive via précédent/suivant.
function ModeItemRoute() {
  const { id } = useParams();
  return <ModeItem key={id || 'today'} />;
}
function ModeGameRoute() {
  const { id } = useParams();
  return <ModeGame key={id || 'today'} />;
}
function ModeCharacterRoute() {
  const { id } = useParams();
  return <ModeCharacter key={id || 'today'} />;
}
function ModeSwordRoute() {
  const { id } = useParams();
  return <ModeSword key={id || 'today'} />;
}

function App() {
  return (
    <div className="home-container">
      <Router>
        <AdRailLeft />

        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />

          <Route exact path="/item" element={<ModeItemRoute />} />
          <Route exact path="/item/:id" element={<ModeItemRoute />} />

          <Route exact path="/game" element={<ModeGameRoute />} />
          <Route exact path="/game/:id" element={<ModeGameRoute />} />

          <Route exact path="/character" element={<ModeCharacterRoute />} />
          <Route exact path="/character/:id" element={<ModeCharacterRoute />} />

          <Route exact path="/sword" element={<ModeSwordRoute />} />
          <Route exact path="/sword/:id" element={<ModeSwordRoute />} />

          <Route exact path="/privacy" element={<PrivacyPolicy />} />
          <Route exact path="/terms" element={<Terms />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact" element={<Contact />} />

          <Route exact path='/history' element={<History />} />
          <Route exact path='/history/:mode' element={<History />} />
          <Route exact path='/history/:mode/:id' element={<History />} />

          <Route path="/library" element={<Library />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Share />
        <Socials />
        <Footer />
        <CookieConsent />

        <AdRailRight />
      </Router>
    </div>
  )
}

export default App